export const getSlotKey = slot => {
  if (!(slot != null && slot.startDate) || !(slot != null && slot.endDate)) {
    return '';
  }
  return `${slot == null ? void 0 : slot.startDate}_${slot == null ? void 0 : slot.endDate}`;
};
export const formatTimeRange = _ref => {
  let {
    locale,
    endDate,
    startDate,
    timezone
  } = _ref;
  const options = {
    hour: 'numeric',
    minute: 'numeric',
    timeZone: timezone
  };
  const startTime = new Intl.DateTimeFormat(locale, options).format(new Date(startDate));
  const endTime = new Intl.DateTimeFormat(locale, options).format(new Date(endDate));
  return `${startTime} - ${endTime}`;
};
export const getFormattedDateLabel = _ref2 => {
  let {
    selectedDate,
    locale,
    timezone
  } = _ref2;
  if (!selectedDate) {
    return '';
  }
  return new Intl.DateTimeFormat(locale, {
    weekday: 'long',
    month: 'short',
    day: 'numeric',
    timeZone: timezone
  }).format(selectedDate);
};
export const getSlotByKey = (key, availabilitySlots) => {
  return availabilitySlots.find(slot => {
    var _slot$slot, _slot$slot2;
    return getSlotKey({
      startDate: slot == null || (_slot$slot = slot.slot) == null ? void 0 : _slot$slot.startDate,
      endDate: slot == null || (_slot$slot2 = slot.slot) == null ? void 0 : _slot$slot2.endDate
    }) === key;
  });
};
export const getSlotIndex = (key, availabilitySlots) => {
  let index;
  availabilitySlots.forEach((slot, i) => {
    var _slot$slot3, _slot$slot4;
    if (getSlotKey({
      startDate: slot == null || (_slot$slot3 = slot.slot) == null ? void 0 : _slot$slot3.startDate,
      endDate: slot == null || (_slot$slot4 = slot.slot) == null ? void 0 : _slot$slot4.endDate
    }) === key) {
      index = i;
    }
  });
  return index;
};
//# sourceMappingURL=utils.js.map